// What a fabric is, in the words a customer shops by ("Pure Cotton", "Poly
// Viscose"), for the fabric cards, the Material filter and search. The mill's
// own name for it ("Elegance 17") stays on the info popup and the summary.
//
// A fabric's own `typeLabel` (if one is set on the doc) wins. Otherwise velvet
// is read from the name, because velvet is a pile and the doc only lists the
// fibre under it, and the rest from `material`, which mills write every which
// way ("Polyester 65%, viscose 35%", "65% polyester, 35% viscose").

const FIBRES = [
    ["cotton", /cotton/],
    ["linen", /linen|flax/],
    ["wool", /wool|merino/],
    ["silk", /silk/],
    ["polyester", /polyester|poly\b|terylene/],
    ["viscose", /viscose|rayon/],
    ["lycra", /lycra|spandex|elastane/],
];

const PURE = { cotton: "Pure Cotton", linen: "Pure Linen", wool: "Pure Wool", silk: "Pure Silk", polyester: "Polyester", viscose: "Viscose" };

const BLENDS = [
    [["polyester", "viscose"], "Poly Viscose"],
    [["polyester", "wool"], "Poly Wool"],
    [["polyester", "cotton"], "Poly Cotton"],
    [["cotton", "linen"], "Cotton Linen"],
];

const titleCase = (s) => s.replace(/\b\w/g, (c) => c.toUpperCase());

export function clothType(fabric) {
    if (!fabric) return "";
    if (typeof fabric.typeLabel === "string" && fabric.typeLabel.trim()) return fabric.typeLabel.trim();
    // cards carry the name as `fabric`, the raw Firestore docs (the filter's source) as `name`
    if (/velvet/i.test(fabric.fabric || fabric.name || "")) return "Velvet";

    const material = String(fabric.material || "").toLowerCase();
    const fibres = FIBRES.filter(([, re]) => re.test(material)).map(([name]) => name);
    if (!fibres.length) return "";
    // stretch is a note on the cloth, not a second cloth: "Cotton Stretch", never "Pure Cotton"
    const stretch = fibres.includes("lycra") && fibres.length > 1;
    const main = stretch ? fibres.filter((f) => f !== "lycra") : fibres;
    if (main.length === 1) return stretch ? `${titleCase(main[0])} Stretch` : (PURE[main[0]] || titleCase(main[0]));
    const blend = BLENDS.find(([pair]) => pair.every((f) => main.includes(f)) && main.length === pair.length);
    return blend ? blend[1] : `${titleCase(main[0])} Blend`;
}

// "Plane" in a few docs is a typo for Plain.
export function clothWeave(fabric) {
    const p = String(fabric?.pattern || "").trim().toLowerCase();
    if (!p) return "";
    return titleCase(p === "plane" ? "plain" : p);
}
